import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\'dubbletrack-player-next-up\'>\n\n</div>")